import { LEVEL_PROGRESSION } from "../../scenes/canvas-scene";
import { DialogRenderer } from "../dialog-renderer";
import { resolve } from "url";
import Condition from "../../core/condition";
import { Achievement } from "../achievements/achievement";
export var RenderingStatus;
(function (RenderingStatus) {
    RenderingStatus[RenderingStatus["RENDERING"] = 0] = "RENDERING";
    RenderingStatus[RenderingStatus["COMPLETED"] = 1] = "COMPLETED";
})(RenderingStatus || (RenderingStatus = {}));
const DEFAULT_CROP = [0, 0, 0, 0];
export default class CanvasRenderer {
    constructor() {
        var _a;
        this.requestID = 0;
        this.listeners = new Set();
        this.dialogRenderer = new DialogRenderer();
        this.canvas = document.getElementById("canvas");
        this.context = (_a = this.canvas) === null || _a === void 0 ? void 0 : _a.getContext("2d");
        this.audio = document.getElementById("audio");
        this.audioSFX = document.getElementById("audioSFX");
    }
    getAchievement() {
        var _a;
        return (_a = this.achievement) !== null && _a !== void 0 ? _a : (this.achievement = new Achievement());
    }
    restart(data, timestamp) {
        this.reset(data);
        data.startTime = timestamp;
    }
    getConnectionTag(data) {
        return;
    }
    addCompleteListener(listener) {
        this.listeners.add(listener);
    }
    changeMusic(music) {
        var _a;
        if (this.audio && (this.audio.src !== resolve(location.href, (_a = music === null || music === void 0 ? void 0 : music.path) !== null && _a !== void 0 ? _a : '') || this.audio.paused)) {
            if (music) {
                this.audio.src = music.path;
                this.audio.play();
                this.audio.loop = music.loop === undefined || music.loop;
            }
            else {
                this.audio.pause();
            }
        }
    }
    playSFX(music) {
        if (this.audioSFX) {
            if (music) {
                this.audioSFX.src = music.path;
                this.audioSFX.play();
                this.audioSFX.loop = false;
            }
            else {
                this.audioSFX.pause();
            }
        }
    }
    reset(data) {
        var _a;
        data.step = 0;
        delete data.stepProgress;
        delete data.startTime;
        data.completed = false;
        delete data.fadeStart;
        delete data.scroll;
        delete data.scrollStart;
        delete data.scrollBackwards;
        delete data.destination;
        delete data.mute;
        if (data.dialog) {
            delete data.dialog.hidden;
            delete data.dialog.lastDialog;
        }
        const persist = JSON.parse((_a = localStorage.getItem(`persist_game`)) !== null && _a !== void 0 ? _a : "{}");
        data.persist = persist;
        this.updateInventory(data);
        this.updateSecret(data);
        if (data.newgrounds) {
            this.getAchievement().loginCheck(data.newgrounds.credentials);
        }
    }
    saveProp(data, prop, value) {
        var _a, _b, _c;
        if (!data.persist) {
            return;
        }
        const sceneData = (_b = data.persist[(_a = data.title) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : (data.persist[(_c = data.title) !== null && _c !== void 0 ? _c : ''] = {});
        sceneData[prop] = value;
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
    }
    getProp(data, prop) {
        var _a, _b, _c;
        return (_c = (_a = data === null || data === void 0 ? void 0 : data.persist) === null || _a === void 0 ? void 0 : _a[(_b = data.title) !== null && _b !== void 0 ? _b : '']) === null || _c === void 0 ? void 0 : _c[prop];
    }
    initializeHero(data, hero) {
        this.getHeroStat(data, hero);
    }
    updateStatsWithLevelProgression(data, hero) {
        var _a, _b;
        if (!data.persist) {
            return false;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const stats = (_b = gameData.stats) !== null && _b !== void 0 ? _b : (gameData.stats = { gold: 0, heroes: [] });
        let didUpdate = false;
        const heroStat = stats.heroes[hero];
        if (!heroStat) {
            return;
        }
        for (let i = LEVEL_PROGRESSION[hero].length - 1; i >= 0; i--) {
            const progression = LEVEL_PROGRESSION[hero][i];
            if (heroStat.xp >= progression.xp) {
                const level = i + 1;
                if (heroStat.level < level) {
                    heroStat.level = level;
                    heroStat.attack = progression.attack;
                    heroStat.max = heroStat.hp = progression.hp;
                    localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
                    this.saveTime(data);
                    didUpdate = true;
                }
            }
        }
        ;
        return didUpdate;
    }
    getHeroStat(data, hero) {
        var _a, _b, _c;
        const dataPersist = data.persist;
        const gameData = (_a = dataPersist.game) !== null && _a !== void 0 ? _a : (dataPersist.game = {});
        const stats = (_b = gameData.stats) !== null && _b !== void 0 ? _b : (gameData.stats = { gold: 0, heroes: [] });
        const heroStat = (_c = stats.heroes[hero]) !== null && _c !== void 0 ? _c : (stats.heroes[hero] = { hp: 0, max: 0, xp: 0, level: 0, attack: 0, xpNext: 0, active: true });
        return heroStat;
    }
    updateLevelProgression(data) {
        var _a, _b;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const stats = (_b = gameData.stats) !== null && _b !== void 0 ? _b : (gameData.stats = { gold: 0, heroes: [] });
        stats.heroes.forEach((heroStat, hero) => {
            var _a;
            const nextProgression = LEVEL_PROGRESSION[hero][heroStat.level];
            const xpNext = ((_a = nextProgression === null || nextProgression === void 0 ? void 0 : nextProgression.xp) !== null && _a !== void 0 ? _a : 10000000) - heroStat.xp;
            if (xpNext != heroStat.xpNext) {
                heroStat.xpNext = xpNext;
                localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
                this.saveTime(data);
            }
        });
    }
    startTime(data) {
        if (!data.persist) {
            return;
        }
        this.saveTime(data);
    }
    saveStats(data, hp, max, hero) {
        var _a, _b;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const stats = (_b = gameData.stats) !== null && _b !== void 0 ? _b : (gameData.stats = { gold: 0, heroes: [] });
        const heroStat = this.getHeroStat(data, hero);
        heroStat.max = max;
        heroStat.hp = Math.max(0, Math.min(hp, max));
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
    }
    addXP(data, xp, hero) {
        var _a, _b, _c, _d;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const stats = (_b = gameData.stats) !== null && _b !== void 0 ? _b : (gameData.stats = { gold: 0, heroes: [] });
        const heroStat = (_c = stats.heroes[hero]) !== null && _c !== void 0 ? _c : (stats.heroes[hero] = { hp: 0, max: 0, xp: 0, level: 0, attack: 0, xpNext: 0 });
        heroStat.xp += xp;
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
        this.playSFX((_d = data.sounds) === null || _d === void 0 ? void 0 : _d.jingle);
    }
    addGold(data, gold) {
        var _a, _b;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const stats = (_b = gameData.stats) !== null && _b !== void 0 ? _b : (gameData.stats = { gold: 0, heroes: [] });
        stats.gold += gold;
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
    }
    addSecret(data, secret) {
        var _a, _b, _c;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const secrets = (_b = gameData.secret) !== null && _b !== void 0 ? _b : (gameData.secret = {});
        secrets[secret] = ((_c = secrets[secret]) !== null && _c !== void 0 ? _c : 0) + 1;
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
        this.updateSecret(data);
    }
    addHp(data, hp, hero) {
        var _a, _b, _c, _d, _e, _f;
        this.saveStats(data, ((_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.stats) === null || _b === void 0 ? void 0 : _b.heroes[hero].hp) !== null && _c !== void 0 ? _c : 0) + hp, (_f = (_e = (_d = data.persist) === null || _d === void 0 ? void 0 : _d.game.stats) === null || _e === void 0 ? void 0 : _e.heroes[hero].max) !== null && _f !== void 0 ? _f : 0, hero);
    }
    removeHp(data, hp, hero) {
        var _a, _b, _c, _d, _e, _f;
        this.saveStats(data, ((_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.stats) === null || _b === void 0 ? void 0 : _b.heroes[hero].hp) !== null && _c !== void 0 ? _c : 0) - hp, (_f = (_e = (_d = data.persist) === null || _d === void 0 ? void 0 : _d.game.stats) === null || _e === void 0 ? void 0 : _e.heroes[hero].max) !== null && _f !== void 0 ? _f : 0, hero);
    }
    saveGameProp(data, prop, value) {
        var _a, _b;
        if (!data.persist) {
            return;
        }
        const gameData = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) !== null && _b !== void 0 ? _b : (data.persist.game = {});
        gameData[prop] = value;
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
    }
    addItem(data, item) {
        var _a, _b, _c;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const inventory = (_b = gameData.inventory) !== null && _b !== void 0 ? _b : (gameData.inventory = {});
        inventory[item] = ((_c = inventory[item]) !== null && _c !== void 0 ? _c : 0) + 1;
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
        this.updateInventory(data);
    }
    updateInventory(data) {
        var _a, _b, _c;
        data.inventory = Object.keys((_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.inventory) !== null && _c !== void 0 ? _c : {})
            .filter(item => !data.itemActions || data.itemActions[item])
            .filter(item => { var _a, _b, _c, _d; return ((_d = (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.inventory) === null || _c === void 0 ? void 0 : _c[item]) !== null && _d !== void 0 ? _d : 0) > 0; });
        data.inventory.sort((item1, item2) => {
            if (item1.length != item2.length) {
                return item1.length - item2.length;
            }
            return item1.localeCompare(item2);
        });
    }
    updateSecret(data) {
        var _a, _b, _c, _d, _e, _f, _g;
        data.secret = (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.secret) !== null && _c !== void 0 ? _c : {};
        data.mainHeroStats = (_g = (_f = (_e = (_d = data.persist) === null || _d === void 0 ? void 0 : _d.game) === null || _e === void 0 ? void 0 : _e.stats) === null || _f === void 0 ? void 0 : _f.heroes) === null || _g === void 0 ? void 0 : _g[0];
    }
    removeItem(data, item) {
        var _a, _b, _c;
        if (!data.persist) {
            return;
        }
        const gameData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        const inventory = (_b = gameData.inventory) !== null && _b !== void 0 ? _b : (gameData.inventory = {});
        inventory[item] = ((_c = inventory[item]) !== null && _c !== void 0 ? _c : 0) - 1;
        if (inventory[item] < 0) {
            delete inventory[item];
        }
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
        this.saveTime(data);
        this.updateInventory(data);
    }
    saveTime(data) {
        var _a;
        if (!data.persist) {
            return;
        }
        const sceneData = (_a = data.persist.game) !== null && _a !== void 0 ? _a : (data.persist.game = {});
        sceneData.saveTime = new Date().getTime();
        if (!sceneData.startTime) {
            sceneData.startTime = new Date().getTime();
        }
        localStorage.setItem(`persist_game`, JSON.stringify(data.persist));
    }
    render(data) {
        window.renderer = this;
        window.scene = data;
        if (!data.persistState) {
            this.reset(data);
        }
        this.listeners.clear();
        this.startLoop(data);
        this.changeMusic(data.mute ? undefined : data.music);
    }
    areDialogsCompleted(data) {
        return this.dialogRenderer.isCompleted(data);
    }
    performRendering(data, timestamp) {
        return RenderingStatus.RENDERING;
    }
    performStart(data) {
        var _a;
        const chance = { rand: Math.random() };
        (_a = data.onStart) === null || _a === void 0 ? void 0 : _a.forEach(action => {
            this.performAction(data, action, chance);
        });
    }
    getRenderingStatus() {
        return RenderingStatus.RENDERING;
    }
    checkMessagesDone(data) {
        var _a;
        if (!data.message && ((_a = data.messages) === null || _a === void 0 ? void 0 : _a.length)) {
            const action = data.messages.shift();
            data.scroll = 0;
            this.performAction(data, action, { rand: Math.random() });
        }
    }
    startLoop(data) {
        const loop = (timestamp) => {
            var _a, _b;
            this.requestID = requestAnimationFrame(loop);
            if (!data.startTime) {
                data.startTime = timestamp;
                this.performStart(data);
            }
            this.checkMessagesDone(data);
            const status = this.performRendering(data, timestamp);
            if (!data.completed && status === RenderingStatus.COMPLETED) {
                data.completed = true;
            }
            if (data.dialog) {
                this.dialogRenderer.render(data, timestamp);
                this.checkMessagesDone(data);
            }
            this.applyFade(data, timestamp);
            this.applyItemUpdate(data);
            if (data.justPickedUp && !data.message) {
                data.justPickedUp = false;
                this.playSFX((_a = data.sounds) === null || _a === void 0 ? void 0 : _a.pickup);
            }
            if (data.medalStart) {
                if (data.medalStart === 1) {
                    data.medalStart = timestamp;
                }
                this.drawAnimation((_b = data.newgrounds) === null || _b === void 0 ? void 0 : _b.animation, timestamp, data.medalStart, false, 64 - 23, 64 - 20);
            }
            if (status === RenderingStatus.COMPLETED) {
                if (data.restartOnDone) {
                    data.restartOnDone = false;
                    this.restart(data, timestamp);
                }
                else {
                    this.performCompletionSteps(data, timestamp);
                }
            }
        };
        this.requestID = requestAnimationFrame(loop);
    }
    applyItemUpdate(data) {
        var _a, _b;
        if (data.itemBonus) {
            (_a = data.itemBonus) === null || _a === void 0 ? void 0 : _a.forEach(item => {
                this.pickItem(data, item, "");
            });
            delete data.itemBonus;
        }
        if (data.itemRemove) {
            (_b = data.itemRemove) === null || _b === void 0 ? void 0 : _b.forEach(item => {
                this.removeItem(data, item);
            });
            delete data.itemRemove;
        }
    }
    startFade(data, timestamp) {
        data.fadeStart = timestamp;
    }
    applyFade(data, timestamp, fadeSeconds) {
        if (!data.fadeStart) {
            return;
        }
        const fade = Math.min(1, (timestamp - data.fadeStart) / (fadeSeconds !== null && fadeSeconds !== void 0 ? fadeSeconds : .5) / 1000);
        if (fade && this.context) {
            this.context.fillStyle = `rgb(0, 0, 0, ${fade !== null && fade !== void 0 ? fade : 0})`;
            this.context.fillRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        }
    }
    performCompletionSteps(data, timestamp) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (data.onEnd) {
            if (!data.step) {
                data.step = 1;
            }
            const [command, param, action] = data.onEnd[data.step - 1];
            switch (command) {
                case "wait":
                    if (!data.stepProgress) {
                        data.stepProgress = {
                            deadline: timestamp + (param !== null && param !== void 0 ? param : 1) * 1000,
                        };
                    }
                    if (timestamp >= data.stepProgress.deadline) {
                        delete data.stepProgress;
                        data.step++;
                    }
                    break;
                case "fade":
                    if (!data.fadeStart) {
                        this.startFade(data, timestamp);
                    }
                    const fade = Math.min(1, (timestamp - ((_a = data.fadeStart) !== null && _a !== void 0 ? _a : 0)) / 1000);
                    if (fade >= 1) {
                        data.step++;
                    }
                    break;
                case "hideLoading":
                    const loadingText = document.getElementById("loadingText");
                    if (loadingText) {
                        loadingText.style.display = "none";
                    }
                    data.step++;
                    break;
                case "next":
                    {
                        const listeners = [];
                        for (let listener of this.listeners) {
                            listeners.push(listener);
                        }
                        this.listeners.clear();
                        const returnData = this.saveReturnData(data);
                        this.reset(data);
                        listeners.forEach(listener => { var _a; return (_a = listener.onComplete) === null || _a === void 0 ? void 0 : _a.call(listener, returnData); });
                    }
                    break;
                case "goto":
                    {
                        const listeners = [];
                        for (let listener of this.listeners) {
                            listeners.push(listener);
                        }
                        this.listeners.clear();
                        const tag = this.getConnectionTag(data);
                        const destination = (_b = param === null || param === void 0 ? void 0 : param.toString()) !== null && _b !== void 0 ? _b : data.destination;
                        const destinationPosition = data.destinationPosition;
                        const destinationDirection = data.destinationDirection;
                        const returnData = this.saveReturnData(data);
                        this.reset(data);
                        listeners.forEach(listener => { var _a, _b; return (_a = listener.onGoto) === null || _a === void 0 ? void 0 : _a.call(listener, (_b = param === null || param === void 0 ? void 0 : param.toString()) !== null && _b !== void 0 ? _b : destination, returnData, destinationPosition, destinationDirection, tag); });
                    }
                    break;
                case "checkGameOver":
                    {
                        if ((_d = (_c = data.persist) === null || _c === void 0 ? void 0 : _c.game.stats) === null || _d === void 0 ? void 0 : _d.heroes.every(({ hp }) => hp <= 0)) {
                            const listeners = [];
                            for (let listener of this.listeners) {
                                listeners.push(listener);
                            }
                            this.listeners.clear();
                            const tag = this.getConnectionTag(data);
                            const destination = (_e = param === null || param === void 0 ? void 0 : param.toString()) !== null && _e !== void 0 ? _e : data.destination;
                            const destinationPosition = data.destinationPosition;
                            const destinationDirection = data.destinationDirection;
                            const returnData = this.saveReturnData(data);
                            this.reset(data);
                            listeners.forEach(listener => { var _a, _b; return (_a = listener.onGoto) === null || _a === void 0 ? void 0 : _a.call(listener, (_b = param === null || param === void 0 ? void 0 : param.toString()) !== null && _b !== void 0 ? _b : destination, returnData, destinationPosition, destinationDirection, tag); });
                        }
                        else {
                            data.step++;
                        }
                    }
                    break;
                case "return":
                    {
                        const listeners = [];
                        for (let listener of this.listeners) {
                            listeners.push(listener);
                        }
                        this.listeners.clear();
                        const destination = (_f = data.returnData) === null || _f === void 0 ? void 0 : _f.scene;
                        const destinationPosition = (_g = data.returnData) === null || _g === void 0 ? void 0 : _g.position;
                        const destinationDirection = (_h = data.returnData) === null || _h === void 0 ? void 0 : _h.direction;
                        const returnData = this.saveReturnData(data);
                        this.reset(data);
                        listeners.forEach(listener => { var _a; return (_a = listener.onGoto) === null || _a === void 0 ? void 0 : _a.call(listener, destination, returnData, destinationPosition, destinationDirection); });
                    }
                    break;
                case "healFully":
                    (_k = (_j = data.persist) === null || _j === void 0 ? void 0 : _j.game.stats) === null || _k === void 0 ? void 0 : _k.heroes.forEach((heroStat, hero) => {
                        var _a, _b;
                        this.saveStats(data, ((_a = heroStat.max) !== null && _a !== void 0 ? _a : 100), ((_b = heroStat.max) !== null && _b !== void 0 ? _b : 100), hero);
                    });
                    this.playSFX((_l = data.sounds) === null || _l === void 0 ? void 0 : _l.heal);
                    data.step++;
                    break;
                case "hideDialogs":
                    if (data.dialog) {
                        data.dialog.hidden = true;
                    }
                    data.step++;
                    break;
                case "action":
                    this.performAction(data, action);
                    data.step++;
                    break;
                case "waitMessage":
                    if (!data.message) {
                        data.step++;
                    }
                    break;
            }
        }
    }
    saveReturnData(data) {
        return { scene: data.title };
    }
    stopRendering() {
        var _a;
        (_a = this.context) === null || _a === void 0 ? void 0 : _a.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        cancelAnimationFrame(this.requestID);
        this.dialogRenderer.stopRendering();
    }
    autoSave(data) {
        clearTimeout(this.saveTimeout);
        this.saveTimeout = setTimeout(() => {
            const returnData = this.saveReturnData(data);
            this.saveGameProp(data, "returnData", returnData);
        }, 1000);
    }
    getHeroName(hero) {
        switch (hero !== null && hero !== void 0 ? hero : 0) {
            case 0:
                return "Blu";
            case 1:
                return "Rob";
            case 2:
                return "Ara";
            case 3:
                return "Stu";
        }
    }
    performAction(data, action, chance) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38;
        if (!action) {
            return false;
        }
        (_a = action === null || action === void 0 ? void 0 : action.actions) === null || _a === void 0 ? void 0 : _a.forEach(action => this.performAction(data, action, chance));
        if ((_b = action.itemsForbidden) === null || _b === void 0 ? void 0 : _b.some(item => { var _a, _b, _c; return (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.inventory) === null || _c === void 0 ? void 0 : _c[item]; })) {
            return false;
        }
        if (action.itemsRequired && !action.itemsRequired.some(item => { var _a, _b, _c; return (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.inventory) === null || _c === void 0 ? void 0 : _c[item]; })) {
            return false;
        }
        if ((_c = action.secretForbidden) === null || _c === void 0 ? void 0 : _c.some(item => { var _a, _b, _c; return (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.secret) === null || _c === void 0 ? void 0 : _c[item]; })) {
            return false;
        }
        if (action.secretRequired && !action.secretRequired.some(secret => { var _a, _b, _c; return (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.secret) === null || _c === void 0 ? void 0 : _c[secret]; })) {
            return false;
        }
        if (chance && action.chance) {
            const actionChance = action.chance * (((_d = data.inventory) === null || _d === void 0 ? void 0 : _d.some(item => item === action.chanceReduced)) ? .5 : 1);
            if (!chance.rand) {
                return false;
            }
            else if (chance.rand <= actionChance) {
                chance.rand = 0;
            }
            else {
                chance.rand -= actionChance;
                return false;
            }
        }
        if (action === null || action === void 0 ? void 0 : action.message) {
            data.message = action.message;
        }
        if (action === null || action === void 0 ? void 0 : action.messages) {
            data.messages = ((_e = data.messages) !== null && _e !== void 0 ? _e : []).concat(action.messages);
        }
        if (action === null || action === void 0 ? void 0 : action.itemBonus) {
            data.itemBonus = action === null || action === void 0 ? void 0 : action.itemBonus;
        }
        if (action === null || action === void 0 ? void 0 : action.itemRemove) {
            data.itemRemove = action === null || action === void 0 ? void 0 : action.itemRemove;
        }
        if (action.sound) {
            this.playSFX(action.sound);
        }
        if (action.subMenu) {
            data.subMenu = true;
        }
        (_f = action.secrets) === null || _f === void 0 ? void 0 : _f.forEach(secret => {
            this.addSecret(data, secret);
        });
        if (action.medal && data.newgrounds) {
            this.getAchievement().unlock({ credentials: data.newgrounds.credentials, medalName: action.medal })
                .then(({ justUnlocked }) => {
                var _a;
                if (justUnlocked) {
                    data.medalStart = 1;
                    this.playSFX((_a = data.newgrounds) === null || _a === void 0 ? void 0 : _a.sound);
                }
            });
        }
        switch (action === null || action === void 0 ? void 0 : action.action) {
            case "clearCache":
                localStorage.removeItem("persist_game");
                break;
            case "goto":
                data.destination = (_g = action.destination) === null || _g === void 0 ? void 0 : _g.scene;
                data.destinationDirection = (_h = action.destination) === null || _h === void 0 ? void 0 : _h.direction;
                data.destinationPosition = (_j = action.destination) === null || _j === void 0 ? void 0 : _j.position;
                break;
            case "showStats": {
                const stats = (_k = data.persist) === null || _k === void 0 ? void 0 : _k.game.stats;
                if (stats) {
                    data.messages = stats.heroes.map(({ active }, index) => ({ active, index }))
                        .map(({ index }) => this.getHeroName(index) +
                        `: HP: ${stats.heroes[index].hp}/${stats.heroes[index].max}. ATK: ${this.getAttack(data, index)}. DEF: ${Math.floor(1 + (1 - this.getDefense(data, index)) * 10)}. XP: ${stats.heroes[index].xp}. LEVEL: ${stats.heroes[index].level}`)
                        .map(message => ({ message }));
                }
                break;
            }
            case "showInventory": {
                const items = Object.keys((_o = (_m = (_l = data.persist) === null || _l === void 0 ? void 0 : _l.game) === null || _m === void 0 ? void 0 : _m.inventory) !== null && _o !== void 0 ? _o : {}).filter(item => {
                    var _a, _b, _c;
                    return (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.inventory) === null || _c === void 0 ? void 0 : _c[item];
                }).map(item => { var _a, _b, _c, _d, _e, _f, _g; return ((_d = (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.inventory) === null || _c === void 0 ? void 0 : _c[item]) !== null && _d !== void 0 ? _d : 1) > 1 ? `${item}:${(_g = (_f = (_e = data.persist) === null || _e === void 0 ? void 0 : _e.game) === null || _f === void 0 ? void 0 : _f.inventory) === null || _g === void 0 ? void 0 : _g[item]}` : item; });
                const stats = (_p = data.persist) === null || _p === void 0 ? void 0 : _p.game.stats;
                if (stats && stats.gold) {
                    items.push(`${stats.gold} gold.`);
                }
                data.message = items.length ? items.join(", ") : "No items.";
                break;
            }
            case "saveStats":
                this.initializeHero(data, (_q = action.hero) !== null && _q !== void 0 ? _q : 0);
                this.updateStatsWithLevelProgression(data, (_r = action.hero) !== null && _r !== void 0 ? _r : 0);
                this.updateLevelProgression(data);
                break;
            case "addGold":
                this.addGold(data, 100);
                this.playSFX((_s = data.sounds) === null || _s === void 0 ? void 0 : _s.pickup);
                data.restartOnDone = true;
                break;
            case "buy":
                if (((_u = (_t = data.persist) === null || _t === void 0 ? void 0 : _t.game.stats) === null || _u === void 0 ? void 0 : _u.gold) && data.persist.game.stats.gold >= ((_v = action.cost) !== null && _v !== void 0 ? _v : 0)) {
                    this.addGold(data, -((_w = action.cost) !== null && _w !== void 0 ? _w : 0));
                    this.playSFX((_x = data.sounds) === null || _x === void 0 ? void 0 : _x.pickup);
                    this.pickItem(data, action.item, (_y = action.message) !== null && _y !== void 0 ? _y : `Here's your ${action.item}. Anything else?`);
                    data.justPickedUp = false;
                }
                else {
                    data.message = `You don't have ${action.cost} gold!`;
                }
                data.restartOnDone = true;
                return false;
            case "noop":
                data.restartOnDone = true;
                break;
            case "hideDialogs":
                if (data.dialog) {
                    data.dialog.hidden = true;
                }
                break;
            case "lastDialog":
                if (data.dialog) {
                    data.dialog.lastDialog = true;
                }
                break;
            case "healFully":
                this.saveStats(data, (_3 = (_0 = (_z = data.persist) === null || _z === void 0 ? void 0 : _z.game.stats) === null || _0 === void 0 ? void 0 : _0.heroes[(_2 = (_1 = action.hero) !== null && _1 !== void 0 ? _1 : data.hero) !== null && _2 !== void 0 ? _2 : 0].max) !== null && _3 !== void 0 ? _3 : 100, (_8 = (_5 = (_4 = data.persist) === null || _4 === void 0 ? void 0 : _4.game.stats) === null || _5 === void 0 ? void 0 : _5.heroes[(_7 = (_6 = action.hero) !== null && _6 !== void 0 ? _6 : data.hero) !== null && _7 !== void 0 ? _7 : 0].max) !== null && _8 !== void 0 ? _8 : 100, (_10 = (_9 = action.hero) !== null && _9 !== void 0 ? _9 : data.hero) !== null && _10 !== void 0 ? _10 : 0);
                this.playSFX((_11 = data.sounds) === null || _11 === void 0 ? void 0 : _11.heal);
                break;
            case "heal":
                this.saveStats(data, ((_17 = (_14 = (_13 = (_12 = data === null || data === void 0 ? void 0 : data.persist) === null || _12 === void 0 ? void 0 : _12.game) === null || _13 === void 0 ? void 0 : _13.stats) === null || _14 === void 0 ? void 0 : _14.heroes[(_16 = (_15 = action.hero) !== null && _15 !== void 0 ? _15 : data.hero) !== null && _16 !== void 0 ? _16 : 0].hp) !== null && _17 !== void 0 ? _17 : 0) + ((_18 = action.amount) !== null && _18 !== void 0 ? _18 : 0), ((_24 = (_21 = (_20 = (_19 = data === null || data === void 0 ? void 0 : data.persist) === null || _19 === void 0 ? void 0 : _19.game) === null || _20 === void 0 ? void 0 : _20.stats) === null || _21 === void 0 ? void 0 : _21.heroes[(_23 = (_22 = action.hero) !== null && _22 !== void 0 ? _22 : data.hero) !== null && _23 !== void 0 ? _23 : 0].max) !== null && _24 !== void 0 ? _24 : 100), (_26 = (_25 = action.hero) !== null && _25 !== void 0 ? _25 : data.hero) !== null && _26 !== void 0 ? _26 : 0);
                this.playSFX((_27 = data.sounds) === null || _27 === void 0 ? void 0 : _27.heal);
                break;
            case "addHero":
                this.initializeHero(data, (_28 = action.hero) !== null && _28 !== void 0 ? _28 : 0);
                this.updateStatsWithLevelProgression(data, (_29 = action.hero) !== null && _29 !== void 0 ? _29 : 0);
                this.updateLevelProgression(data);
                break;
            case "activateHero": {
                const heroStat = (_31 = (_30 = data.persist) === null || _30 === void 0 ? void 0 : _30.game.stats) === null || _31 === void 0 ? void 0 : _31.heroes[(_32 = action.hero) !== null && _32 !== void 0 ? _32 : 0];
                if (heroStat) {
                    heroStat.active = true;
                }
                break;
            }
            case "deactivateHero": {
                const heroStat = (_34 = (_33 = data.persist) === null || _33 === void 0 ? void 0 : _33.game.stats) === null || _34 === void 0 ? void 0 : _34.heroes[(_35 = action.hero) !== null && _35 !== void 0 ? _35 : 0];
                if (heroStat) {
                    heroStat.active = false;
                }
                break;
            }
            case "hideLoading": {
                const loadingText = document.getElementById("loadingText");
                if (loadingText) {
                    loadingText.style.display = "none";
                }
                break;
            }
            case "startTime": {
                this.startTime(data);
                break;
            }
            case "postTime": {
                if (((_36 = data.persist) === null || _36 === void 0 ? void 0 : _36.game.startTime) && ((_37 = data.newgrounds) === null || _37 === void 0 ? void 0 : _37.credentials)) {
                    this.getAchievement().postScore({ credentials: data.newgrounds.credentials, value: new Date().getTime() - ((_38 = data.persist) === null || _38 === void 0 ? void 0 : _38.game.startTime) });
                }
                break;
            }
        }
        return true;
    }
    getWeaponAttack(data) {
        var _a, _b, _c, _d;
        if ((_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.inventory) === null || _b === void 0 ? void 0 : _b["trident"]) {
            return 15;
        }
        if ((_d = (_c = data.persist) === null || _c === void 0 ? void 0 : _c.game.inventory) === null || _d === void 0 ? void 0 : _d["sword"]) {
            return 10;
        }
        return 5;
    }
    getArmorReduction(data) {
        var _a, _b, _c, _d;
        if ((_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.inventory) === null || _b === void 0 ? void 0 : _b["goldcloth"]) {
            return .5;
        }
        if ((_d = (_c = data.persist) === null || _c === void 0 ? void 0 : _c.game.inventory) === null || _d === void 0 ? void 0 : _d["armor"]) {
            return .7;
        }
        return 1;
    }
    getDefense(data, hero) {
        return this.getArmorReduction(data);
    }
    getAttack(data, hero) {
        var _a, _b, _c;
        return Math.floor(this.getWeaponAttack(data) * ((_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.stats) === null || _b === void 0 ? void 0 : _b.heroes[hero].attack) !== null && _c !== void 0 ? _c : 1));
    }
    pickItem(data, item, messageOverride) {
        var _a;
        if (!item) {
            data.message = messageOverride !== null && messageOverride !== void 0 ? messageOverride : `The chest is empty.`;
        }
        else {
            const [, gold] = (_a = item.match(/(\d+)\sgold/)) !== null && _a !== void 0 ? _a : [];
            if (gold) {
                if (messageOverride !== "") {
                    data.message = messageOverride !== null && messageOverride !== void 0 ? messageOverride : `You found ${item}`;
                }
                this.addGold(data, parseInt(gold));
                data.justPickedUp = true;
            }
            else {
                this.addItem(data, item);
                if (messageOverride !== "") {
                    data.message = messageOverride !== null && messageOverride !== void 0 ? messageOverride : `You found a ${item}`;
                }
                data.justPickedUp = true;
            }
        }
    }
    drawAnimation(animation, timestamp, startTime, looping = false, px = 0, py = 0) {
        var _a, _b, _c, _d, _e, _f;
        const timeEllapsed = timestamp - (startTime !== null && startTime !== void 0 ? startTime : 0);
        if (this.context && ((_a = animation === null || animation === void 0 ? void 0 : animation.asset) === null || _a === void 0 ? void 0 : _a.image)) {
            const frame = timeEllapsed && (animation === null || animation === void 0 ? void 0 : animation.frameRate) ? Math.floor(animation.frameRate * timeEllapsed / 1000) : 0;
            const [sx, sy, width, height, animating] = (_b = animation === null || animation === void 0 ? void 0 : animation.getCrop(frame, looping)) !== null && _b !== void 0 ? _b : DEFAULT_CROP;
            this.context.drawImage(animation.asset.image, sx, sy, width, height, px + ((_d = (_c = animation === null || animation === void 0 ? void 0 : animation.position) === null || _c === void 0 ? void 0 : _c.x) !== null && _d !== void 0 ? _d : 0), py + ((_f = (_e = animation === null || animation === void 0 ? void 0 : animation.position) === null || _e === void 0 ? void 0 : _e.y) !== null && _f !== void 0 ? _f : 0), width, height);
            return { animating };
        }
        return {};
    }
    renderSlides(data, timestamp) {
        var _a, _b, _c, _d, _e, _f;
        const { slides } = data;
        if (slides) {
            let minRateEllapsed = 1;
            const timeEllapsed = timestamp - ((_a = data.startTime) !== null && _a !== void 0 ? _a : 0);
            for (let slide of slides) {
                if (Condition.eval(slide.hidden, { scene: data })) {
                    slide.currentlyHidden = true;
                    continue;
                }
                if (slide.currentlyHidden) {
                    slide.currentlyHidden = false;
                    slide.timeAnim = timestamp;
                }
                const animEllapsed = slide.timeAnim ? timestamp - slide.timeAnim : timeEllapsed;
                const rateEllapsed = Math.min((slide === null || slide === void 0 ? void 0 : slide.duration) ? animEllapsed / (slide.duration * 1000) : 1, 1);
                const x = (slide.to.x * rateEllapsed + slide.from.x * (1 - rateEllapsed));
                const y = (slide.to.y * rateEllapsed + slide.from.y * (1 - rateEllapsed));
                minRateEllapsed = Math.min(rateEllapsed, minRateEllapsed);
                if (this.context) {
                    this.context.save();
                    if (slide.scale) {
                        this.context.scale(slide.scale, slide.scale);
                    }
                    if ((_b = slide === null || slide === void 0 ? void 0 : slide.asset) === null || _b === void 0 ? void 0 : _b.image) {
                        this.context.drawImage((_c = slide.asset) === null || _c === void 0 ? void 0 : _c.image, x, y);
                    }
                    const animation = slide === null || slide === void 0 ? void 0 : slide.animation;
                    if ((_d = animation === null || animation === void 0 ? void 0 : animation.asset) === null || _d === void 0 ? void 0 : _d.image) {
                        const frame = animEllapsed && (animation === null || animation === void 0 ? void 0 : animation.frameRate) ? Math.floor(animation.frameRate * animEllapsed / 1000) : 0;
                        const [sx, sy, width, height] = (_e = animation === null || animation === void 0 ? void 0 : animation.getCrop(frame, slide.looping)) !== null && _e !== void 0 ? _e : DEFAULT_CROP;
                        this.context.drawImage((_f = animation === null || animation === void 0 ? void 0 : animation.asset) === null || _f === void 0 ? void 0 : _f.image, sx, sy, width, height, x, y, width, height);
                    }
                    this.context.restore();
                }
            }
            if (minRateEllapsed >= 1) {
                if (!this.areDialogsCompleted(data)) {
                    return RenderingStatus.RENDERING;
                }
                return RenderingStatus.COMPLETED;
            }
        }
        return RenderingStatus.RENDERING;
    }
}
